export default __webpack_public_path__ + "static/media/call.7f950695.svg";